<template>
  <!-- 设备详情 -->
  <div class="equipDetails">
    <div class="details_content">
      <div class="details_left">
        <div class="equipInfo">
          <div>
            <el-image class="equipInfoImg" :src="dataForm.picKey ? dataForm.picKey : '@/assets/img/morentupian.png' ">
            <div slot="error">
              <img class="equipInfoImg" src="@/assets/img/morentupian.png" />
            </div>
          </el-image>
          </div>
          <div class="equipInfo_content">
            <div class="details_name">{{dataForm.name}}</div>
            <el-descriptions :column="1" :colon="false">
              <el-descriptions-item label-class-name="my-label" label="设备型号">{{dataForm.model}}</el-descriptions-item>
              <el-descriptions-item label-class-name="my-label" label="供应商">{{dataForm.manufacturer}}</el-descriptions-item>
              <el-descriptions-item label-class-name="my-label" label="咨询次数">{{dataForm.frequency}}次</el-descriptions-item>
              <el-descriptions-item label-class-name="my-label" label="价格">{{ dataForm.quotationType ? `￥${dataForm.price}` : '面议' }}</el-descriptions-item>
          </el-descriptions>
            <div style="width: 300px">
              <el-button type="primary" class="clickLook" size="small" @click="qrcodeVisible = true">立即咨询</el-button>
            </div>
          </div>
        </div>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.introduction">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>项目简介
          </div>
          <div class="editorContent" v-html="dataForm.introduction">
          </div>
        </el-card>
        <el-card class="details_box-card" shadow="never" v-if="dataForm.coreParameters">
          <div slot="header" class="clearfix">
            <div class="descicon"></div>核心参数
          </div>
          <div class="editorContent" v-html="dataForm.coreParameters">
          </div>
        </el-card>
      </div>
      <div class="details_right">
        <div class="descicon"></div>
        <span class="right_title">技术顾问</span>
        <div class="technical">
          <el-image class="lxfs" src="https://pstatic.navi-sci.cn/order/zhuangwei.png">
            <div slot="error">
              <img class="lxfs" src="@/assets/img/morentupian.png" />
            </div>
          </el-image>
          <br />
          <span>与技术顾问一对一沟通</span>
        </div>
        <div class="my_ys">
          <div class="descicon"></div>
          <span class="right_title">我们的优势</span>
          <img class="ys" src="@/assets/img/ys.png" />
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="qrcodeVisible" width="400px" append-to-body>
      <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <img style="width: 250px" src="https://pstatic.navi-sci.cn/%E5%BA%84%E4%B8%BA%281%29.png" />
        <div>扫描二维码添加客服</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      qrcodeVisible: false,
      dataForm: {}
    }
  },
  created () {
    this.dataForm = JSON.parse(this.$route.params.data)
  },
}
</script>

<style lang="scss" scoped>
.equipDetails .el-descriptions-item__label:not(.is-bordered-label) {
  width: 110px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}
.equipDetails .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 20px;
}
</style>
<style scoped lang="scss">
.equipInfo {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 350px;
  background: #ffffff;
  border-radius: 7px;
  padding: 20px;
  margin-bottom: 30px;
  margin-top: 70px;
  padding-left: 50px;
}
.equipInfoImg {
  width: 200px;
  height: 140px;
  text-align: center;
}
.equipInfo_content {
  margin-left: 80px;
}
.details_name {
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 30px;
  
}
.details_subname {
  // display: flex;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 25px;

}
.details_subname_name {
  width: 100px;
  float: left;
  height: 45px;
}
.details_subname_other {
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.details_box-card {
  margin-bottom: 30px;
}
  .ys {
    width: 300px;
    margin-top: 20px;
  }
  .my_ys {
    margin-top: 30px;
  }
</style>